<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <!-- <p class="eyebrow">Material Transfer</p> -->
        <div class="header-title-row">
          <!-- <h2>Store Print Preview</h2> -->
          <div class="toolbar">
            <mat-slide-toggle color="primary" [(ngModel)]="includeSignature">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <!-- <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Invoice
            </button> -->
            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
        <!-- <p class="subtext">
          E-way bill inspired material transfer print with movement, challan, and transporter details.
        </p> -->
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div *ngIf="previewData.logo" class="page-watermark">
          <img [src]="previewData.logo" alt="Company watermark" />
        </div>

        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img *ngIf="previewData.logo; else logoFallback" [src]="previewData.logo" alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Transfer Dispatch Desk</div>
            <h1>{{ previewData.companyName }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">MATERIAL TRANSFER</div>
            <p><strong>Transfer Code:</strong> {{ previewData.transferCode }}</p>
            <p><strong>Transfer Date:</strong> {{ previewData.transferDate }}</p>
            <p *ngIf="previewData.challanNo"><strong>Challan No:</strong> {{ previewData.challanNo }}</p>
            <p *ngIf="previewData.challanDate !== '-'"><strong>Challan Date:</strong> {{ previewData.challanDate }}</p>
          </div>
        </div>

        <div class="overview-grid">
          <div class="overview-card">
            <span class="overview-label">Transfer Type</span>
            <strong>{{ previewData.transferType || '-' }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Items</span>
            <strong>{{ previewData.totalItems }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Transfer Qty</span>
            <strong>{{ previewData.totalQty }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Transfer Amount</span>
            <strong>{{ previewData.transferAmount }}</strong>
          </div>
        </div>

        <div class="movement-grid">
          <section class="movement-card">
            <div class="movement-badge">Dispatch From</div>
            <h3>{{ previewData.fromBranchName }}</h3>
            <p *ngIf="previewData.fromDepartmentName">{{ previewData.fromDepartmentName }}</p>
            <p *ngIf="previewData.fromBranchAddress">{{ previewData.fromBranchAddress }}</p>
          </section>

          <section class="movement-card movement-card--to">
            <div class="movement-badge movement-badge--to">Deliver To</div>
            <h3>{{ previewData.toBranchName }}</h3>
            <p *ngIf="previewData.toBranchAddress">{{ previewData.toBranchAddress }}</p>
          </section>

          <section class="movement-card movement-card--transport">
            <div class="movement-badge movement-badge--transport">Transport</div>
            <p *ngIf="previewData.transporterMode !== '-'"><strong>Mode:</strong> {{ previewData.transporterMode }}</p>
            <p *ngIf="previewData.transporterName !== '-'"><strong>Transporter:</strong> {{ previewData.transporterName }}</p>
            <p *ngIf="previewData.transporterDocNo !== '-'"><strong>Doc No:</strong> {{ previewData.transporterDocNo }}</p>
            <p *ngIf="previewData.transporterDocDate !== '-'"><strong>Doc Date:</strong> {{ previewData.transporterDocDate }}</p>
            <p *ngIf="previewData.truckNo !== '-'"><strong>Vehicle No:</strong> {{ previewData.truckNo }}</p>
          </section>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>SR</th>
              <th>ITEM</th>
              <th>UOM</th>
              <th>BATCH</th>
              <th>AVAILABLE</th>
              <th>REQUESTED</th>
              <th>TRANSFER</th>
              <th>RECEIVED</th>
              <th>RATE</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData.items">
              <td class="center">{{ item.sr }}</td>
              <td class="item-title">{{ item.productName }}</td>
              <td class="center">{{ item.uom }}</td>
              <td class="center">{{ item.batchNo || '-' }}</td>
              <td class="right">{{ item.availableQty }}</td>
              <td class="right">{{ item.requestedQty }}</td>
              <td class="right strong">{{ item.transferQty }}</td>
              <td class="right">{{ item.receivedQty }}</td>
              <td class="right">{{ item.rate }}</td>
              <td class="right strong">{{ item.lineAmount }}</td>
            </tr>
          </tbody>
        </table>

        <div class="bottom-grid">
          <div class="details-block">
            <section *ngIf="previewData.status">
              <h3>Transfer Status</h3>
              <p>{{ previewData.status }}</p>
            </section>

            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="summary-card-stack">
              <div class="summary-mini-card">
                <span class="overview-label">Challan No</span>
                <strong>{{ previewData.challanNo || '-' }}</strong>
              </div>
              <div class="summary-mini-card">
                <span class="overview-label">Vehicle No</span>
                <strong>{{ previewData.truckNo || '-' }}</strong>
              </div>
            </div>

            <div class="html-sign-area">
              <div class="sign-company">For {{ previewData.companyName }}</div>
              <div class="sign-assets" *ngIf="includeSignature && (previewData.signatureImage || previewData.stampImage)">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Authorized Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || 'Authorized Signatory' }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>Material Transfer Document</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">Generating material transfer preview...</p>
    </div>
  </ng-template>
</div>
